<template>
  <div class="cs-default-layout">
    <resize-sensor @resize="HeightTransition" />
    <div class="cs-default-container" :style="containerStyle">
      <magiclogin />
      <Header />
      <div
        class="main-wraper"
        :style="isInIframe ? 'padding-top: 60px;padding-bottom: 30px' : ''"
      >
        <slot />
      </div>
      <PoweredBy />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import PoweredBy from "@/components/PoweredBy.vue";
import { mapGetters } from "vuex";
import { INITIAL_ROUTE } from "@/store/modules/user/consts";
import helper from "@/utils/helper";

export default {
  name: "default-layout",
  components: {
    Header,
    PoweredBy,
  },
  computed: {
    ...mapGetters({
      hostedPageId: "user/getHostedPageId",
      cart: "user/cart",
    }),
    isInIframe() {
      return helper.isInIframe();
    },
    containerStyle() {
      // If inside iframe → no height override
      if (this.isInIframe) {
        return {};
      }

      // If outside iframe and small screen → height 100vh
      if (window.innerWidth <= 680) {
        return { height: "100vh" };
      }

      return {};
    },
  },
  mounted() {
    this.$nextTick(async () => {
      // coinbase window check
      const searchParams = new URL(window.location).searchParams;
      if (searchParams.get("code")) {
        return;
      }
      // In iframe, order data arrives via postMessage (rocketfuel_send_cart).
      if (helper.isInIframe()) {
        return;
      }
      // Hosted / select-currency paths carry order id in URL; skip cart redirect for them.
      if (
        !INITIAL_ROUTE.some((route) => window.location.pathname.includes(route))
      ) {
        if (this.hostedPageId && !Object.keys(this.cart).length) {
          this.$router.push({
            name: "SelectCurrency",
            params: { id: this.hostedPageId },
          });
        } else if (!this.hostedPageId && !Object.keys(this.cart).length) {
          this.invalidOrder();
        }
      }
    });
  },
  methods: {
    HeightTransition() {
      const body = document.body;

      requestAnimationFrame(() => {
        // Don't set height, just measure it
        const measuredHeight = body.offsetHeight;
        const newHeight = measuredHeight;

        // Only notify if changed
        if (this.heightTo === measuredHeight) {
          return;
        }

        this.heightTo = measuredHeight;

        this.notifyParentWindow({
          type: "rocketfuel_change_height",
          data: `${newHeight}px`,
        });

        this.notifyParentWindow({
          type: "rocketfuel_new_height",
          data: newHeight,
        });
      });
    },
  },
};
</script>

<style lang="scss">
$default-container-width: 420px;

.main-wraper {
  padding-left: 15px;
  padding-right: 15px;
}

.cs-default-layout {
  height: 100%;
  width: 100%;
}

.cs-default-container {
  width: $default-container-width;
  margin: 30px auto;
  overflow-y: auto;
  background-color: #ffffff;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  min-height: 100%;
  box-shadow: 0 0 5px rgba(12, 12, 12, 0.5);
  border-radius: 8px;

  @media (max-width: 1024px) {
    margin: 30px auto;
    width: $default-container-width;
    /* Adjust the width for tablets */
  }

  @media (max-width: 768px) {
    width: $default-container-width;
    /* Adjust the width for standard mobile devices */
    margin: 30px auto;
  }

  @media (max-width: 680px) {
    width: 100%;
    /* Adjust the width for small mobile devices */
    min-height: 600px;
    margin: auto;
    // padding: 10px;
  }
}
</style>
